// App.js
import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Drawer, List, ListItem, ListItemText, Divider, Container, Box, Avatar, Grid } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoImage from '../Images/KESTATES-LOGO.png'; // Import your logo 
import LogoImage2 from '../Images/k-estates-icon-logo.png'; // Import your logo image
import { Link, useNavigate } from 'react-router-dom';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import MessageIcon from '@mui/icons-material/Message';
import './index.css';
import picture1 from '../Images/image1001.webp'
import { logOut } from '../Pages/Login/sliceLogin';
import storage from 'redux-persist/lib/storage';
import { useDispatch, useSelector } from 'react-redux';
import {Dropdown} from 'antd'
import { profileImageBaseUrl } from '../Pages/Server/baseUrls';

function AdminHeader() {
    const tokenInfo = useSelector((state) => state.login.token);
    const userInfo = useSelector((state) => state.login.user);
    // console.log("***** User Info ***** ", userInfo);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const items = [
        {
        key: '1',
        label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
            1st menu item
            </a>
        ),
        },
    
    ];
  
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const fLogOut = () => {
    storage.removeItem() // or sessionStorage.clear();
    setDrawerOpen(false);
    dispatch(logOut({}));
    navigate("./")
}


    // Sample user data
    const user = {
        name: 'Farooq Alam',
        role: 'Admin',
        email: 'farooq@kestates.ae',
        // avatarUrl: 'https://via.placeholder.com/150', // Placeholder image URL
        avatarUrl: LogoImage2
      };
    

  return (
    <div>
      
      <AppBar position="sticky" style={{ backgroundColor:'black', height:'6.25rem', alignItems:'center', justifyContent:"center" }} >
        <Container maxWidth="l" className='headerContainer' style={{ display:'flex', flexDirection:'row', alignItems:'center',  }} >
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={toggleDrawer}
                >
                    <MenuIcon />
                </IconButton>
                  <Link to={'./'} >
                      <img src={LogoImage} alt="Logo" className='header_style' />   
                  </Link>
            </Toolbar>
    
            <Toolbar style={{ width:'7%', display:'flex', flexDirection:'row', alignItems:"center", justifyContent:"space-between" }}  >
              <NotificationsActiveIcon />
              {
                userInfo.profile_image ? 
                    <Avatar  alt='logo' src={profileImageBaseUrl+"/"+userInfo.profile_image}/>
                    :
                    <Avatar  alt='logo' src={picture1}/>
              }
            </Toolbar>

        </Container>

        {/* <Grid container item spacing={2} style={{ display:'flex', flexDirection:'row', alignItems:'center', justifyContent:"space-between" }} bgcolor={'red'}  >
            <Grid sx={8} sm={8} md={8}>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={toggleDrawer}
                >
                    <MenuIcon />
                </IconButton>
                  <Link to={'./'} >
                      <img src={LogoImage} alt="Logo" style={{ width: '12.5rem', height: '3.74rem', backgroundSize:'cover'}} />   
                  </Link>
            </Grid>
    
            <Grid sx={4} sm={4} md={4} style={{ width:'7%', display:'flex', flexDirection:'row', alignItems:"center", justifyContent:"space-between" }}  >
              <NotificationsActiveIcon />
              <Avatar alt='logo' src={picture1}/>
            </Grid>

        </Grid> */}

      </AppBar>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer} sx={{ '& .MuiDrawer-paper': { backgroundColor: '#000',   width: '280px' } }} className='drawer-style' >
        <Box sx={{ p: 5, textAlign: 'center', backgroundColor: '#000'}}>
          <Avatar alt={user.name} src={user.avatarUrl} sx={{ width: 100, height: 100, margin: '0 auto' }} />
          <Typography variant="subtitle1" sx={{ color: '#fff', marginTop: 1 }}>{user.name}</Typography>
          <Typography variant="body2" sx={{ color: '#fff' }}>{user.role}</Typography>
          {/* <Typography variant="body2" sx={{ color: '#fff' }}>{user.email}</Typography> */}
          <Typography variant="body2" sx={{ color: '#fff', marginTop: '3rem' }}>Version: 1.7.6</Typography>
          <Typography variant="body2" sx={{ color: '#fff' }}>Updated By: 15th May</Typography>
        </Box>
        <Divider />
        <List sx={{color:'white', }}>
            <Link to="./Clients" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }} >
                <ListItem 
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                        '&:hover': {
                          backgroundColor: '#f5f5f5', 
                          color:'#000'
                        },
                    }}
                >
                    <ListItemText primary="Clients" />
                </ListItem>
            </Link>
            
            <Link to="./Deleted-Clients" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }} >
                <ListItem 
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                        '&:hover': {
                          backgroundColor: '#f5f5f5', 
                          color:'#000'
                        },
                    }}
                >
                    <ListItemText primary="Deleted Clients" />
                </ListItem>
            </Link>
            <Link to="./Properties" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }}>
                <ListItem
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                            '&:hover': {
                            backgroundColor: '#f5f5f5', 
                            color:'#000'
                        },
                    }}
                >   
                    <ListItemText primary="Properties" />
                </ListItem>
            </Link>
            <Link to="./Locations" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }}>
                <ListItem
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                            '&:hover': {
                            backgroundColor: '#f5f5f5', 
                            color:'#000'
                        },
                    }}
                >   
                    <ListItemText primary="Locations" />
                </ListItem>
                
            </Link>

            <Link to="./Developers" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }}>
                <ListItem
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                            '&:hover': {
                            backgroundColor: '#f5f5f5', 
                            color:'#000'
                        },
                    }}
                >   
                    <ListItemText primary="Developers" />
                </ListItem>
                
            </Link>

            <Link to="./PropertyTypes" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }}>
                <ListItem
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                            '&:hover': {
                            backgroundColor: '#f5f5f5', 
                            color:'#000'
                        },
                    }}
                >   
                    <ListItemText primary="PropertyTypes" />
                </ListItem>
                
            </Link>


            <Link to="./Transactions" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }} >
                <ListItem 
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                        '&:hover': {
                          backgroundColor: '#f5f5f5', 
                          color:'#000'
                        },
                    }}
                >
                    <ListItemText primary="Transactions" />
                </ListItem>
            </Link>

            <Link to="./Residential" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }} >
                <ListItem 
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                        '&:hover': {
                          backgroundColor: '#f5f5f5', 
                          color:'#000'
                        },
                    }}
                >
                    <ListItemText primary="Residential" />
                </ListItem>
            </Link>
            <Link to="./ResidentialProjects" onClick={toggleDrawer} style={{ textDecoration: 'none', color: 'inherit' }} >
                <ListItem 
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                        '&:hover': {
                          backgroundColor: '#f5f5f5', 
                          color:'#000'
                        },
                    }}
                >
                    <ListItemText primary="ResidentialProjects" />
                </ListItem>
            </Link>
            

            <Link to="./" onClick={fLogOut} style={{ textDecoration: 'none', color: 'inherit' }}>
                <ListItem
                    style={{ cursor: 'pointer', alignSelf:'center' }} 
                    sx={{
                            '&:hover': {
                            backgroundColor: '#f5f5f5', 
                            color:'#000'
                        },
                    }}
                >   
                    <ListItemText primary="LogOut" />
                </ListItem>
            </Link>
        </List>
      </Drawer>

      <div style={{ padding: '20px' }}>
        {/* <Typography variant="h4">Main Content</Typography> */}
        {/* Your main content goes here */}
      </div>

    </div>
  );
}

export default AdminHeader;
